import request from '@/utils/request'

// 收款方式列表接口（无分页）
export const getPaymentMethod = (data: any) =>
  request({
    url: `/manage/fiat-payout/support/method`,
    method: 'post',
    data
  })

// 发起付款
export const setPayeePayment = (data: any) =>
  request({
    url: `/manage/fiat-payout`,
    method: 'post',
    data
  })
